import {Injectable} from '@angular/core';
import EventTrackingModel from '../../../models/event-tracking.model';
import {EventEnum} from '../../../enums/event.enum';
import {SessionService} from './session.service';
import {HttpService} from './http.service';

@Injectable({
    providedIn: 'root'
})
export class EventTrackingService {
    static PROGRESS_STEP = 5;

    public sendEvents = true;
    public showLogs = true;

    constructor(
        private sessionService: SessionService,
        private httpService: HttpService
    ) {}

    track(eventName: EventEnum, eventData?: object) {
        const event = new EventTrackingModel();
        event.action = eventName;
        event.appInstanceToken = this.sessionService.appInstanceToken;
        event.session = this.sessionService.sessionToken;
        event.uid = this.sessionService.uid;
        event.videoId = this.sessionService.videoId;

        if (eventData) {
            event.addCustomData(eventData);
        }

        this.sendEvent(event);
    }

    private sendEvent(event: EventTrackingModel) {
        if (this.sendEvents) {
            return this.httpService.storeEvent(event.toJson());
        } else if (this.showLogs) {
            // eslint-disable-next-line no-console
            console.info('📒 Event tracking', event.toJson());
        }
    }
}
